import type { ApiRequestInterface } from '@zg-rentals/web-base';
import { getClient } from './client';
import { httpApiRequest } from './httpApiRequest';

export const httpFrontEndRequest = <G, P, R>(request: ApiRequestInterface<G, P>, client = getClient()) =>
  httpApiRequest<G, P, R>({ unwrapApiLayerResponse: true, ...request }, client);
